import React from 'react';
import { motion } from 'framer-motion';

export default function About() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="py-20 bg-white min-h-[70vh]"
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-serif text-gray-900 mb-4">About Tatvam</h1>
          <div className="w-16 h-1 bg-[#d4af37] mx-auto"></div>
        </div>

        <div className="prose prose-lg mx-auto text-gray-700 space-y-8">
          <p className="text-xl leading-relaxed text-center font-serif text-gray-800">
            Tatvam (Tatvam Retail) is a premium menswear retail and tailoring brand offering high-quality suit and shirting fabrics along with custom tailoring services.
          </p>

          <div className="bg-[#faf9f6] p-8 border-l-4 border-[#d4af37] space-y-4 shadow-sm">
            <p className="font-bold text-gray-900 text-lg">
              Tatvam is a registered brand owned and operated by Yashvi Enterprises.
            </p>
            <p className="text-gray-800 font-medium">
              This brand operates under the verified business entity Yashvi Enterprises.
            </p>
            <p className="text-gray-700">
              Yashvi Enterprises is owned by Aditya Dalmia.
            </p>
          </div>

          <div className="text-center p-6 border border-gray-100">
            <h3 className="text-sm font-bold uppercase tracking-widest text-[#d4af37] mb-3">Business Nature</h3>
            <p className="text-gray-700">
              We operate as a retail showroom providing premium fabrics and tailoring services in Jaipur, India.
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}